import { SUPPORT_EMAIL_ADDRESS } from "@/lib/support-actions";
import { Link } from "@tanstack/react-router";
import { siFacebook, siInstagram } from "simple-icons";

const BrandIcon = ({ path }: { path: string }) => {
  return (
    <svg viewBox="0 0 24 24" className="size-5" fill="currentColor" aria-hidden="true">
      <path d={path} />
    </svg>
  );
};

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container py-12">
        <div className="grid gap-8 md:grid-cols-4">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/veronics_cream.png" alt="Veronics Logo" width="256" height="65" className="h-6 w-auto" />
            </div>
            <p className="text-primary-foreground/70 text-sm">Simpler operations for flexible learning communities.</p>
            <div className="mt-4 flex items-center gap-4">
              <a
                href="https://www.facebook.com/profile.php?id=61577022772656"
                target="_blank"
                rel="noreferrer"
                className="text-primary-foreground/70 hover:text-accent transition-colors"
                aria-label="Visit Veronics on Facebook"
              >
                <BrandIcon path={siFacebook.path} />
              </a>
              <a
                href="https://www.instagram.com/hello.veronics/"
                target="_blank"
                rel="noreferrer"
                className="text-primary-foreground/70 hover:text-accent transition-colors"
                aria-label="Visit Veronics on Instagram"
              >
                <BrandIcon path={siInstagram.path} />
              </a>
            </div>
          </div>
          {/* <div>
            <h3 className="font-bold mb-4">Product</h3>
            <ul className="gap-y-2">
              <li>
                <Link to="." href="#" className="text-primary-foreground/70 hover:text-accent text-sm">
                  Features
                </Link>
              </li>
              <li>
                <Link to="." href="#" className="text-primary-foreground/70 hover:text-accent text-sm">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="." href="#" className="text-primary-foreground/70 hover:text-accent text-sm">
                  Integrations
                </Link>
              </li>
              <li>
                <Link to="." href="#" className="text-primary-foreground/70 hover:text-accent text-sm">
                  Roadmap
                </Link>
              </li>
            </ul>
          </div> */}
          <div>
            <h3 className="mb-4 font-semibold">Company</h3>
            <ul className="flex flex-col gap-y-2">
              <li>
                <Link to="/features" className="text-primary-foreground/70 hover:text-accent text-sm">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/about-us" className="text-primary-foreground/70 hover:text-accent text-sm">
                  About Us
                </Link>
              </li>
              {/* <li>
                <Link to="." href="#" className="text-primary-foreground/70 hover:text-accent text-sm">
                  Blog
                </Link>
              </li> */}
              {/* <li>
                  <Link to="." href="#" className="text-primary-foreground/70 hover:text-accent text-sm">
                    Careers
                  </Link>
                </li> */}
              <li>
                <Link to="/contact-us" className="text-primary-foreground/70 hover:text-accent text-sm">
                  Contact
                </Link>
              </li>
              <li>
                <a
                  href={`mailto:${SUPPORT_EMAIL_ADDRESS}`}
                  className="text-primary-foreground/70 hover:text-accent text-sm"
                >
                  Support
                </a>
              </li>
              <li>
                <Link to="/whats-new" className="text-primary-foreground/70 hover:text-accent text-sm">
                  What's New
                </Link>
              </li>
            </ul>
          </div>
          {/* <div>
              <h3 className="font-bold mb-4">Resources</h3>
              <ul className="gap-y-2">
                <li>
                  <Link to="." href="#" className="text-primary-foreground/70 hover:text-accent text-sm">
                    Documentation
                  </Link>
                </li>
                <li>
                  <Link to="." href="#" className="text-primary-foreground/70 hover:text-accent text-sm">
                    Help Center
                  </Link>
                </li>
                <li>
                  <Link to="." href="#" className="text-primary-foreground/70 hover:text-accent text-sm">
                    Community
                  </Link>
                </li>
                <li>
                  <Link to="." href="#" className="text-primary-foreground/70 hover:text-accent text-sm">
                    Webinars
                  </Link>
                </li>
              </ul>
            </div> */}
        </div>
        <div className="border-t border-primary-foreground/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-primary-foreground/70 text-sm">© {currentYear} Veronics. All rights reserved.</p>
          {/* <div className="flex gap-6 mt-4 md:mt-0">
              <Link to="." href="#" className="text-primary-foreground/70 hover:text-accent text-sm">
                Privacy Policy
              </Link>
              <Link to="." href="#" className="text-primary-foreground/70 hover:text-accent text-sm">
                Terms of Service
              </Link>
              <Link to="." href="#" className="text-primary-foreground/70 hover:text-accent text-sm">
                Cookie Policy
              </Link>
            </div> */}
        </div>
      </div>
    </footer>
  );
};
